import Configurations from './Configurations';

export function createVueConfigurations(options)
{
    return new VueConfigurations(options)
}

export class VueConfigurations
{
    constructor(options = {})
    {
        this._configurations = new Configurations(options);
    }

    initialize(configs)
    {
        this._configurations.initialize(configs);
    }

    install(app, {globalPropertyKey})
    {
        app.config.globalProperties[globalPropertyKey] = this._configurations;
    }

    get(key, def = null)
    {
        return this._configurations.get(key, def);
    }

    set(key, value)
    {
        this._configurations.set(key, value);
    }

    has(key)
    {
        return this._configurations.has(key);
    }
};
